import { useState } from 'react';
import { footerNav } from '../data';

export default function SiteFooter() {
  const [sub, setSub] = useState('');

  return (
    <footer id="subscribe" className="bg-secondary-200/60">
      {/* 订阅区 */}
      <div className="mx-auto max-w-6xl px-4 pt-8 md:px-6 md:pt-12">
        <div className="flex flex-col items-start justify-between gap-6 rounded-lg bg-secondary-200/70 p-6 md:flex-row md:items-center">
          <div>
            <h3 className="font-heading text-xl font-semibold text-foreground-900 md:text-2xl">别错过下一波讨论浪潮</h3>
            <p className="mt-1.5 text-sm text-foreground-700">
              订阅 91黑料 每日热度简报，实时热搜与焦点关注一次送到你手上。
            </p>
          </div>
          <div className="flex w-full max-w-md flex-col gap-2 sm:flex-row">
            <input
              type="email"
              value={sub}
              onChange={(e) => setSub(e.target.value)}
              placeholder="输入你的邮箱"
              aria-label="订阅邮箱"
              className="min-w-0 flex-1 rounded-md border border-foreground-900/15 bg-background-50 px-4 py-2.5 text-sm text-foreground-800 outline-none transition-colors focus:border-primary-400"
            />
            <button className="inline-flex h-10 items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-600 px-5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-500">
              立即订阅 <i className="ri-mail-send-line"></i>
            </button>
          </div>
        </div>
      </div>

      {/* 链接区 */}
      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-8 border-t border-foreground-900/10 px-4 py-10 sm:grid-cols-2 lg:grid-cols-4 md:px-6">
        <div>
          <a href="#top" className="flex items-baseline gap-1.5">
            <span className="font-heading text-xl font-semibold tracking-tight text-foreground-950">91黑料</span>
            <span className="text-[11px] font-medium tracking-[0.3em] text-primary-600">HOT RANK</span>
          </a>
          <p className="mt-3 text-sm leading-relaxed text-foreground-700">
            紧跟91黑料热门与排行，汇总当下话题与热搜焦点，实时追踪关注度变化，不错过任何一波讨论浪潮。
          </p>
          <div className="mt-4 flex items-center gap-2">
            {['ri-twitter-x-line', 'ri-weibo-line', 'ri-quill-pen-line', 'ri-rss-line'].map((ic, i) => (
              <button
                key={i}
                aria-label="社交入口"
                className="flex h-9 w-9 items-center justify-center rounded-md border border-foreground-900/15 text-foreground-700 transition-colors hover:bg-background-50"
              >
                <i className={`${ic} text-base`}></i>
              </button>
            ))}
          </div>
        </div>

        {footerNav.map((col) => (
          <nav key={col.title}>
            <h4 className="text-sm font-semibold text-foreground-900">{col.title}</h4>
            <ul className="mt-3 space-y-2">
              {col.links.map((l) => (
                <li key={l}>
                  <a href="#top" className="text-sm text-foreground-600 transition-colors hover:text-primary-700">{l}</a>
                </li>
              ))}
            </ul>
          </nav>
        ))}
      </div>

      {/* 底部声明 */}
      <div className="border-t border-foreground-900/10">
        <div className="mx-auto flex max-w-6xl flex-col items-start justify-between gap-2 px-4 py-5 text-xs text-foreground-500 sm:flex-row sm:items-center md:px-6">
          <p>© 2026 91黑料 · 实时热度追踪平台 · 演示页面</p>
          <p className="max-w-xl leading-relaxed">
            本站内容均为演示数据，仅作站型与功能示意，不构成对任何真实人物或事件的指认。请理性看待网络信息。
          </p>
        </div>
      </div>
    </footer>
  );
}